import { useSelector } from 'react-redux';

export const useGetPostTiles = ({ uuid }) => {
  const tiles = useSelector(state => state.campaignDnd[`post-${uuid}`] || []);

  return tiles;
};
